import {
  DialogContent,
  Dialog as MuiDialog,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import Menu from './Menu';

export default function Dialog({
  open,
  onClose,
}: Readonly<{
  open: boolean;
  onClose: () => void;
}>) {
  const { t } = useTranslation();

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: '4px',
            maxWidth: '480px',
            width: '100%',
            margin: { xs: 1.5, sm: 3 },
          },
        },
      }}
    >
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <DialogTitle
          component='h3'
          variant='h4'
          sx={{ paddingX: 2, flexGrow: 1, paddingY: 0 }}
        >
          {t('readingView.account.title')}
        </DialogTitle>
        <IconButton
          aria-label={t('readingView.aboutBook.close')}
          onClick={onClose}
          size='large'
        >
          <CloseIcon role='presentation' />
        </IconButton>
      </Stack>
      <DialogContent dividers sx={{ padding: 0 }}>
        <Menu />
      </DialogContent>
    </MuiDialog>
  );
}
